define('uikit/modules/visualsearch',['require','exports','module','underscore','marionette','backbone','../mixins/component.mixin','../channel','../templates','../elements/label','../extra/key.codes'],function(require, exports, module){
  var _ = require('underscore');
  var Mn = require('marionette');
  var Backbone = require('backbone');
  var ComponentMixin = require('../mixins/component.mixin');
  var channel = require('../channel');
  var Templates = require('../templates');
  var Label = require('../elements/label');
  var CODES = require('../extra/key.codes');

  /** Deprecated **/
  /** This component is no longer supported, use the Token Input instead. **/

  var VisualSearchToken = Backbone.Model.extend({
    defaults: {
      text: 'text',
      value: ''
    }
  });

  // Clear browser selections
  var clearSelection    = function() {
    var selection = window.getSelection();

    if (selection.rangeCount > 0) {
      selection.getRangeAt(0).startContainer.parentNode.blur();
    }

    selection.removeAllRanges();
  };

  // Only applies to text nodes
  var getCursorPosition = function() {
    var selection  = document.getSelection(),
        caretRange = {};

    if (selection.rangeCount > 0) {
      caretRange = selection.getRangeAt(0);
    }

    return {
      caretStart      : caretRange.startOffset,
      caretEnd        : caretRange.endOffset,
      selectionLength : caretRange.endOffset - caretRange.startOffset
    }
  };

  var setCursorAt = function(el, position) {
    var range = document.createRange(),
        sel   = null;

    el.focus();

    // If no text nodes exists, first create
    if (!el.childNodes.length) {
      var textNode = document.createTextNode('');
      el.appendChild(textNode);
    }

    sel = window.getSelection();
    range.setStart(el.childNodes[0], position);
    range.collapse(true);
    sel.removeAllRanges();
    sel.addRange(range);
  };

  var VisualSearchTokenView = Label.extend({

    template: Templates.UIKit['visual.search.token'],

    options: _.extend({}, Label.prototype.options, {
      editing: false,
      selected: false,
      icon: 'remove circle'
    }),

    forceUpdate: _.extend({}, Label.prototype.forceUpdate, {
      icon: true
    }),

    bindings: {
      text: 'text',
      detail: 'value'
    },

    ui: {
      detail  : '.detail'
    },

    events: {
      'keydown'                   : 'handleKeydown',
      'keyup .detail'             : 'handleKeyupOnDetail',
      'keydown .detail'           : 'handleKeydownOnDetail'
    },

    triggers: {
      'blur'                      : 'deselect',
      'blur .detail'              : 'not:editing deselect',
      'focus'                     : 'selected',
      'focus .detail'             : 'editing',
      'click .icon.remove.circle' : 'close'
    },

    setCursorToStart: function() {
      var el = this.ui.detail.get(0);

      setCursorAt(el, 0);
    },

    setCursorToEnd: function() {
      var el = this.ui.detail.get(0);

      setCursorAt(el, el.textContent.length);
    },

    setTextContent: function(text) {
      this.ui.detail.text(text);

      this.setCursorToEnd();
    },

    setFocus: function() {
      this.$el.focus();
      return this;
    },

    setFocusOnEdit: function() {
      this.ui.detail.focus();
    },

    handleKeydown: function(ev) {
      if (this.el == ev.target) { // Only apply if parent element in focus
        if (ev.keyCode === CODES.BACKSPACE_KEY || ev.keyCode === CODES.DELETE_KEY) {
          ev.preventDefault();
          this.triggerMethod('close');
        }
      }
    },

    handleKeydownOnDetail: function(ev) {
      var self       = this,
          keyCode    = ev.keyCode,
          sel        = document.getSelection(),
          caretRange = sel.getRangeAt(0),
          caretStart = caretRange.startOffset,
          caretEnd   = caretRange.endOffset,
          selLength  = caretEnd - caretStart,
          oldValue   = ev.target.textContent;

      if (selLength) {
        ev.stopPropagation();
      }

      if (keyCode === CODES.ENTER_KEY) {
        ev.preventDefault();
      } else if (keyCode === CODES.TAB_KEY) {
        ev.stopPropagation();
      } else if (keyCode === CODES.RIGHTARROW_KEY && caretStart !== this.detail.length) {
        ev.stopPropagation();
      } else if (keyCode === CODES.LEFTARROW_KEY && caretStart !== 0) {
        ev.stopPropagation();
      } else if (keyCode === CODES.DOWNARROW_KEY || keyCode == CODES.UPARROW_KEY) {
        ev.preventDefault();
      } else if (keyCode === CODES.BACKSPACE_KEY && caretStart == 0 && !selLength) {
        ev.preventDefault();

        clearSelection();
        this.setFocus();
      } else if (keyCode === CODES.ESCAPE_KEY) {
        ev.preventDefault();
        this.ui.detail.blur();
        this.triggerMethod('close');
      } else {
        _.defer(function() {
          // Avoid setting off change event because of other key codes
          if (oldValue !== ev.target.textContent) {
            self._setOption('detail', ev.target.textContent, { internal: true });

            self.triggerMethod('value:edit', ev.target.textContent);
          }
        });
      }
    },

    handleKeyupOnDetail: function(ev) {
      if (ev.keyCode === CODES.ENTER_KEY) {
        this._setOption('detail', ev.target.textContent, { internal: true });

        this.triggerMethod('complete');
      }
    },

    onRender: function() {
      this.ui.detail.attr('contentEditable', 'true');
    },

    serializeData: function() {
      var d = Label.prototype.serializeData.apply(this, arguments);
      d.text += ' :';
      return d;
    },

    updateAttributes: function() {
      Label.prototype.updateAttributes.apply(this, arguments);

      this.addClass('selected', this.getBoolOption('selected'));
      this.addClass('editing', this.getBoolOption('editing'));

      this.$el.attr('tabindex', -1);
    }

  });

  var VisualSearchResultItemView = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'result',

    tagName: 'a',

    options: {
      text : '',
      selected : false
    },

    forceUpdate: { text: true },

    triggers: {
      'mousedown'   : 'selected'
    },

    template: Templates.UIKit['visual.search.result'],

    updateAttributes: function() {
      this.addClass('active', this.getBoolOption('selected'));
    }

  });

  var VisualSearchResultFooterView = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'result footer',

    tagName: 'span',

    options: {
      count: '',
      text : ''
    },

    forceUpdate: { count: true, text: true },

    triggers: {
      'mousedown'   : 'press'
    },

    template: Templates.UIKit['visual.search.result.footer']

  });

  var VisualSearchResultsView = Mn.CollectionView.extend(ComponentMixin).extend({

    className : 'results',

    tagName   : 'div',

    childView : VisualSearchResultItemView,

    childViewOptions: function() {
      return { bindings: _.clone(this.childBindings) };
    },

    options: {
      collection: null,
      empty: true
    },

    forceUpdate: { collection: true, empty: true },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);

      this.updateEmptyProperty();
    },

    showFooter: function(options) {
      if (_.isEmpty(this.children)) {
        return;
      }

      var footer = new VisualSearchResultFooterView(options),
          self   = this;

      // Remove any previous footer
      this.hideFooter();

      this.footer = footer;

      footer.render();
      footer.$el.appendTo(this.$el);

      footer.on('press', function() {
        self.triggerMethod('press:footer');
      });
    },

    hideFooter: function() {
      if (this.footer) {
        this.footer.remove();
      }
    },

    getSelectedResult: function() {
      return this.selected && this.selected.text;
    },

    onChildviewSelected: function(v) {
      this.selectResult(v._index);

      this.triggerMethod('result:selected', v);
    },

    selectResult: function(index, ignoreSet) {
      var v = null;

      if (this.collection && this.collection.models[index]) {
        v = this.children.findByModel(this.collection.models[index]);
      }

      // Deselect all others
      this.children.without(v).forEach(function(c) {
        c.selected = false;
      });

      if (v) {
        v.selected = true;

        this.scrollResultIntoView(v);
      }

      this.selected = v;

      if (!ignoreSet) {
        this.triggerMethod('result:text', v);
      }
    },

    scrollResultIntoView: function(result) {
      var itemHeight        = result.$el.outerHeight(),
          itemPosTop        = result.$el.position().top,
          itemPosBottom     = itemPosTop + itemHeight,

          listHeight        = this.$el.height(),
          listScrollTop     = this.$el.scrollTop();

      // Item is hiding below the results view
      if (itemPosBottom > listHeight) {
        // Scroll enough to show the rest of the item
        var scrollMore = itemHeight - (listHeight - itemPosTop);

        this.$el.scrollTop(listScrollTop + scrollMore);

      // Item is hiding above the results view
      } else if (itemPosTop < 0) {
        // Decrement the scrolling by the negative position of the item
        this.$el.scrollTop(listScrollTop + itemPosTop);
      }
    },

    selectNextResult: function() {
      var selected = this.selected,
          index    = 0;

      if (selected) {
        index = this.collection.indexOf(selected.model) + 1;
      }

      if (index < this.children.length) {
        this.selectResult(index);
      }
    },

    selectPreviousResult: function () {
      var selected = this.selected,
          index    = null;

      if (selected) {
        index = this.collection.indexOf(selected.model) - 1;
      }

      this.selectResult(index);
    },

    selectFirstResult: function() {
      this.selected = null;

      if (!_.isEmpty(this.collection)) {
        this.selectResult(0, true);
      }
    },

    onBeforeRender: function() {
      this.triggerMethod('results:added');
    },

    onAddChild: function() {
      this.triggerMethod('results:added');

      this.selectFirstResult();
      this.hideFooter();
    },

    onRemoveChild: function(v) {
      v.selected = false;

      this.selectFirstResult();
      this.hideFooter();
    },

    onRenderCollection: function() {
      this.selectResult(0, true);

      this.hideFooter();
    },

    onChangeCollection: function() {
      if (this.collection) {
        this.listenTo(this.collection, 'add remove reset update', _.debounce(this.updateEmptyProperty));
      }

      this.updateEmptyProperty();
    },

    updateEmptyProperty: function() {
      this.empty = !this.collection || this.collection.isEmpty();
    },

    updateAttributes: function() {
      this.addClass('empty', this.getBoolOption('empty'));
    }

  });

  var VisualSearchView = Mn.CompositeView.extend(ComponentMixin).extend({

    className: 'ui visual search',

    childView: VisualSearchTokenView,

    childViewContainer: '.token.box',

    childViewEventPrefix: 'token',

    template: Templates.UIKit['visual.search'],

    options: {
      collection: null,
      placeholder: 'Click to search',
      icon: 'search',
      visible: true
    },

    forceUpdate: {
      collection: true,
      placeholder: true,
      icon: true,
      visible: true
    },

    childEvents: {
      'fieldResultsView:result:selected' : 'selectFieldResult',
      'tokenResultsView:result:selected' : 'selectTokenResult',
      'fieldResultsView:results:added'   : 'newSearchResults',
      'tokenResultsView:results:added'   : 'newSearchResults',
      'tokenResultsView:result:text'     : 'setSearchResultText',
      'tokenResultsView:press:footer'    : 'tokenResultsFooterPress'
    },

    events: {
      'blur @ui.input'                        : 'handleInputBlur',
      'keydown'                               : 'handleKeydown',
      'keydown @ui.input'                     : 'handleInputKeydown',
      'keyup @ui.input'                       : 'handleInputKeyup',
      'mousedown .prompt'                     : 'handleMousedown',
      'mousedown @ui.input'                   : 'handleInputMousedown',
      'mousedown @ui.tokens'                  : 'handleTokensMousedown',
      'mousedown @ui.clearResults'            : 'handleClearIconMousedown',
      'click @ui.clearResults'                : 'handleClearAll'
    },

    collectionEvents : {
      'remove' : function(t) { this.triggerMethod('token:remove', t); }
    },

    ui: {
      input               : '.token.input',
      tokens              : '.token.box',
      clearResults        : '.token.clear.icon',
      placeholder         : '.placeholder'
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);

      this.tokenResultsView = new VisualSearchResultsView();
      this.fieldResultsView = new VisualSearchResultsView();
    },

    tokenResultsFooterPress: function() {
      var selected = this.selected;
      this.triggerMethod('search:press:footer', selected.detail, selected.text);
    },

    defineNewTokenObj: function(selected) {
      var tokenObj      = {},
          results       = this.fieldResultsView,
          selectedText  = selected || results.getSelectedResult();

      if (selectedText) {
        tokenObj.text = selectedText;
      } else {
        tokenObj.text = results.default || 'Text';
        tokenObj.value = this.ui.input.text();
      }

      return tokenObj;
    },

    generateNewToken: function(selected) {
      var token     = new VisualSearchToken(this.defineNewTokenObj.apply(this, arguments)),
          tokenView = null;

      this.collection.push(token);

      tokenView = this.children.findByModel(token);

      if (!this.isFieldResultsEmpty() || selected) {
        token._newToken = true;

        this.hideFieldResultsView();

        tokenView.setCursorToStart();
      } else {
        this._tokenCreated(token);
      }

      this.ui.input.text('');
    },

    focusCursorOnInput: function() {
      var input = this.ui.input.get(0);

      setCursorAt(input, input.textContent.length);

      // Hide placeholder if displayed
      this.ui.placeholder.hide();
    },

    handleClearAll: function() {
      var tokens = this.collection.models.slice(0),
          self   = this;

      tokens.forEach(function(token) {
        self.collection.remove(token);
      });

      // Trigger blur to hide any popups and show placeholder
      this.ui.input.blur();
    },

    handleTokensMousedown: function(ev) {
      ev.originalEvent.ignoreFocus = true;
    },

    handleInputMousedown: function(ev) {
      ev.originalEvent.ignoreCursor = true;
    },

    handleClearIconMousedown: function(ev) {
      ev.stopPropagation();
    },

    handleMousedown: function(ev) {
      if (!ev.originalEvent.ignoreFocus) {

        if (!ev.originalEvent.ignoreCursor) {
          ev.preventDefault();
          this.focusCursorOnInput();
        }

        this.triggerMethod('search:field', this.ui.input.text());
      }
    },

    handleInputBlur: function(ev) {
      this.hideFieldResultsView();

      this.showPlaceholder();
    },

    showPlaceholder: function() {
      if (!(this.collection && this.collection.length) && !this.ui.input.text().length) {
        this.ui.placeholder.show();
      }
    },

    setSearchResultText: function(v, result) {
      var text = result ? result.text : this.selected.detail;

      this.selected.setTextContent(text);
    },

    newSearchResults: function(v) {
      // this.changeResultsPopupPosition(v);
    },

    selectFieldResult: function(results, selected) {
      this.generateNewToken(selected.text);
    },

    selectTokenResult: function(results, selected) {
      this.selected.detail = selected.text;

      this.selected.triggerMethod('complete');
    },

    handleInputKeydown: function(ev) {
      var tokens = this.children;

      this.ui.placeholder.hide();

      this._inputOldValue = this.ui.input.text();

      if (ev.keyCode === CODES.ENTER_KEY) {
        ev.preventDefault();

      } else if (ev.keyCode === CODES.BACKSPACE_KEY) {
        if (!this.ui.input.text().length && tokens.length) {
          tokens.findByIndex(tokens.length-1).setFocus();
        }
      } else if (ev.keyCode === CODES.DOWNARROW_KEY && !this.isFieldResultsEmpty()) {
        ev.preventDefault();

        this.fieldResultsView.selectNextResult();
      } else if (ev.keyCode === CODES.UPARROW_KEY && !this.isFieldResultsEmpty()) {
        ev.preventDefault();

        this.fieldResultsView.selectPreviousResult();
      } else if (ev.keyCode === CODES.ESCAPE_KEY) {
        ev.preventDefault();
        this.ui.input.text('');
        this.ui.input.blur()
      }
    },

    handleInputKeyup: function(ev) {
      var textContent = this.ui.input.text();

      if (ev.keyCode === CODES.DOWNARROW_KEY || ev.keyCode === CODES.UPARROW_KEY && !this.isFieldResultsEmpty()) {
        ev.preventDefault();
      } else if (ev.keyCode === CODES.ENTER_KEY) {
        ev.preventDefault();

        this.generateNewToken();
      } else {
        if (this._inputOldValue != textContent) {
          this.triggerMethod('search:field', textContent);
        }
        this._inputOldValue = null;
      }
    },

    handleKeydown: function(ev) {
      var keyCode   = ev.keyCode,
          currView  = this.selected,
          index     = null,
          view      = null;

      // Handle key events propagated by the token views

      if (!currView) {
        return;
      } else {
        index = this.collection.indexOf(currView.model);
      }

      // Key events triggered in token view
      if (keyCode === CODES.LEFTARROW_KEY) {
        // If cursor on text, set token to focus
        if (currView.editing) {
          clearSelection();
          currView.setFocus();
        } else {
        // Otherwise set cursor on previous token
          --index;

          if (index > -1) {
            ev.preventDefault();
            clearSelection();

            this.children.findByModel(this.collection.at(index))
              .setCursorToEnd();
          }
        }
      } else if (keyCode === CODES.RIGHTARROW_KEY) {
        // If cursor on text, focus next token
        if (currView.editing) {
          clearSelection();

          ++index;

          if (index < this.collection.length) {

            this.children.findByModel(this.collection.at(index))
              .setFocus()
              .triggerMethod('selected');
          } else if (index == this.collection.length) {
            this.ui.input.focus();
          }
        } else {
          ev.preventDefault();
          clearSelection();

        // Otherwise set cursor on current token text
          currView.setCursorToStart();
        }
      } else if (keyCode === CODES.DOWNARROW_KEY && !this.isTokenResultsEmpty()) {
        ev.preventDefault();

        this.tokenResultsView.selectNextResult();
      } else if (keyCode === CODES.UPARROW_KEY && !this.isTokenResultsEmpty()) {
        ev.preventDefault();

        this.tokenResultsView.selectPreviousResult();
      }
    },

    hideFieldResultsView: function() {
      this.fieldResultsView.collection = null;
    },

    hideTokenResultsView: function() {
      this.tokenResultsView.collection = null;
    },

    isFieldResultsEmpty: function() {
      return !(this.fieldResultsView.collection && this.fieldResultsView.collection.length);
    },

    isTokenResultsEmpty: function() {
      return !(this.tokenResultsView.collection && this.tokenResultsView.collection.length);
    },

    onRender: function() {
      // Unbind first, in case events have been binded
      this.unbindEntityEvents(this.collection, this.getOption('collectionEvents'));

      this.bindEntityEvents(this.collection, this.getOption('collectionEvents'));

      this.showPlaceholder();
    },

    onTokenClose: function(v) {
      var self = this;

      this.selected = null;

      v.hide({
        animation: 'scale',
        onComplete: function() {
          self.collection.remove(v.model);

          self.focusCursorOnInput();
        }
      });
    },

    onTokenValueEdit: function(v, value) {
      this.triggerMethod('search:value', value, v.text);
    },

    onTokenComplete: function(v) {
      if (!this.isTokenResultsEmpty() && this.tokenResultsView.selected) {
        v.detail = this.tokenResultsView.getSelectedResult();
      }

      if (v.model._newToken) {
        this._tokenCreated(v.model);

        v.model._newToken = false;
      } else {
        this._tokenRevised(v.model);
      }
    },

    onTokenEditing: function(v) {
      if (!v.selected) {
        this.selectToken(v);
      }

      v.editing = true;

      var self = this;
      _.defer(function() {
        self.triggerMethod('search:value', v.detail, v.text);
      })
    },

    onTokenNotEditing: function(v) {
      v.editing = false;

      this.hideTokenResultsView();
    },

    onTokenDeselect: function(v) {
      this.selected = null;

      v.selected = false;
    },

    onTokenSelected: function(v) {
      this.selectToken(v);
    },

    _tokenCreated: function(token) {
      this.triggerMethod('token:add', token);

      clearSelection();
    },

    _tokenRevised: function(token) {
      this.triggerMethod('token:revised', token);

      clearSelection();
    },

    selectToken: function(v) {
      this.selected = v;

      this.children.without(v).forEach(function(c) {
        c.selected = false;
        c.editing = false;
      })

      v.selected = true;
    },

    changeResultsPopupPosition: function(results) {
      var el    = this.selected ? this.selected.$el : this.ui.input,
          width = el.outerWidth();

      results.$el.css({
        left: el.position().left + width - 10,
        top: el.position().top + 1.5 * parseInt(el.css('font-size'))
      });
    },

    updateAttributes: function() {
      this.addClass('icon', this.getBoolOption('icon'));
    }

  });

  // register the table component
  channel.reply('visualsearch', function() {
    return VisualSearchView;
  });

  VisualSearchView.ResultsView = VisualSearchResultsView;

  module.exports = VisualSearchView;
});
